import { PlotPoint } from '../_generated/api/tagged-hardware'

const verify = (v: any, fallback: number = 0): number => (typeof v === 'number' ? v : fallback)

export default class Vector2 implements PlotPoint {
    public x: number
    public y: number

    static from(point: PlotPoint) {
        return new Vector2(point.x, point.y)
    }

    static list(points: PlotPoint[]) {
        return points.map(({ x, y }) => new Vector2(x, y))
    }

    constructor(x?: number, y?: number) {
        this.x = verify(x)
        this.y = verify(y)
    }
}
